/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'
import { WHOLE_JBP_AUDIT_FRAGMENT } from '../fragments/WholeJBPAuditFragment'

export const GET_JBP_AUDIT = gql`
  query GetJBPAudit($id: ID!, $companyStoreId: ID!) {
    JBPAudit(id: $id) {
      ...WholeJBPAudit
    }
  }
  ${WHOLE_JBP_AUDIT_FRAGMENT}
`
